import React, { useEffect, useState } from 'react';
import { Button, Icon, Link, Logo } from '@components';
import styled from 'styled-components';
import { breakpoints } from '@config';
import { useMatchMedia } from '@utils';

export interface WrapperProps {
  scrolled: number;
}

export interface LinksProps {
  open: boolean;
}

const Wrapper = styled.header<WrapperProps>`
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  column-gap: 32px;
  background: ${({ scrolled, theme }) => (scrolled > 0) && theme.colors.bgMoreTransparency};
  backdrop-filter: ${({ scrolled }) => (scrolled > 0) && 'blur(12px)'};
  box-sizing: border-box;
  padding-left: 1rem;
  padding-right: 1rem;
  transition: 0.3s ease-out;
  z-index: 9999;

  @media (min-width: ${breakpoints.pc}) {
    justify-content: flex-start;
    height: 76px;
  }
`;

const Links = styled.div<LinksProps>`
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  gap: 32px;
  background: ${({ theme }) => theme.colors.bg};
  transform: ${({ open }) => open ? 'none' : 'translateY(-100%)'};
  opacity: ${({ open }) => open ? 1 : 0};
  transition: 0.3s ease-out;
  will-change: transform;
  box-sizing: border-box;
  padding: 96px 16px 32px;
  margin-left: auto;
  z-index: -1;

  @media (min-width: ${breakpoints.pc}) {
    position: static;
    flex-direction: row;
    width: auto;
    background: transparent;
    padding: 0;
  }
`;

const StyledIcon = styled(Icon)`
  cursor: pointer;

  @media (min-width: ${breakpoints.pc}) {
    display: none;
  }
`;

const Header: React.FC = () => {
  const [ openMenu, setOpenMenu ] = useState(false);
  const [ scrolled, setScrolled ] = useState(0);
  const match = useMatchMedia(breakpoints.pc);
  
  const handleScroll: () => void = () => {
    setScrolled(window.scrollY);
  };
  
  const handleClick: () => void = () => {
    console.log('ok')
    if (!match) {
      setOpenMenu(!openMenu);
    }
  };
  
  useEffect(() => {
    setOpenMenu(match);
  }, [ match ]);
  
  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
    }
  }, []);
  
  return (
    <Wrapper scrolled={scrolled}>
      <Logo />
      <Links open={openMenu}>
        <Link href={'#for-what'} onClick={handleClick}>Для чего</Link>
        <Link href={'#technologies'} onClick={handleClick}>Технологии</Link>
        <Button
          as={'a'}
          href={'#test'}
          size={'sm'}
          theme={'dark'}
          fullWidth={!match}
          onClick={handleClick}
        >
          Попробовать
        </Button>
      </Links>
      <StyledIcon glyph={openMenu ? 'close' : 'burger'}
                  size={24}
                  onClick={handleClick}
      />
    </Wrapper>
  )
}

export { Header };
